import React from 'react';
import styled from 'styled-components';
import { environment } from '../../utils';

const tek = `${environment.REACT_APP_STATIC_URL}/img/2022/sponsors/tek.png`;
// const siili = `${environment.REACT_APP_STATIC_URL}/img/2022/sponsors/Siili_white.png`;
// const knowit = `${environment.REACT_APP_STATIC_URL}/img/2022/sponsors/knowit.png`;
// const granlund = `${environment.REACT_APP_STATIC_URL}/img/2023/sponsors/granlund_white.png`;
const nitor = `${environment.REACT_APP_STATIC_URL}/img/2023/sponsors/nitor_white.svg`;
const fonum = `${environment.REACT_APP_STATIC_URL}/img/2024/sponsors/fonum_white.png`;
// const tter = `${environment.REACT_APP_STATIC_URL}/img/2019/TTER.png`;
const wibax = `${environment.REACT_APP_STATIC_URL}/img/2024/sponsors/wibax-logo-white-cmyk.svg`;
// const fatLizart = `${environment.REACT_APP_STATIC_URL}/img/2025/sponsors/FL_logo-black_web.png`;
const ABB = `${environment.REACT_APP_STATIC_URL}/img/2025/sponsors/2000px-ABB_logo_red.svg.png`;
const celsius = `${environment.REACT_APP_STATIC_URL}/img/2026/sponsors/Celsius.png`;
const heko = `${environment.REACT_APP_STATIC_URL}/img/2026/sponsors/heko-logo.png`;
// const oikia = `${environment.REACT_APP_STATIC_URL}/img/2025/sponsors/Oikiasipsi_Logo_musta_RGB.png`;
// const aInsinoorit = `${environment.REACT_APP_STATIC_URL}/img/2025/sponsors/A_insinoorit.png`;
// const avp = `${environment.REACT_APP_STATIC_URL}/img/2024/sponsors/AVP_Black kopio.svg`;
const bos = `${environment.REACT_APP_STATIC_URL}/img/2026/sponsors/BOS.png`;
const granlund = `${environment.REACT_APP_STATIC_URL}/img/2026/sponsors/Granlund.png`;
const hsy = `${environment.REACT_APP_STATIC_URL}/img/2026/sponsors/hsy-logo.png`;
const rajupaja = `${environment.REACT_APP_STATIC_URL}/img/2026/sponsors/rajupaja.png`;
const espoo = `${environment.REACT_APP_STATIC_URL}/img/2026/sponsors/espoo.png`;
const nocfo = `${environment.REACT_APP_STATIC_URL}/img/2026/sponsors/nocfo.svg`;

const SponsorContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: flex-start;
  align-items: center;
  margin: 1rem 0 0 -2rem;

  & > * {
    margin: 0 0 2rem 2rem;
    height: 80px;
    width: 160px;

    ${(props) =>
      props.medium &&
      `
      height: 150px;
      width: 300px;
    `}

    ${(props) =>
      props.semilarge &&
      `
      height: 200px;
      width: 400px;
    `}

    ${(props) =>
      props.large &&
      `
      height: 250px;
      width: 500px;
    `}

    ${(props) =>
      props.xl &&
      `
      height: 400px;
      width: 750px;
    `}

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

const SponsorImg = styled.img`
  ${(p) =>
    p.invert &&
    `
    filter: invert(100%);
  `}

  ${(p) =>
    p.whiteBG &&
    `
    background-color: white;
    border: 67px solid white
    width: unset !important;
  `}
`;

const Sponsor = ({ src, alt, invert, whiteBG }) => (
  <div>
    <SponsorImg
      src={src}
      alt={alt}
      invert={invert}
      whiteBG={whiteBG}
      loading="lazy"
    />
  </div>
);

export const SponsorPyramid = () => {
  return (
    <div>
      {/* <SponsorContainer large>
        <Sponsor src={siili} alt="Siili" />
      </SponsorContainer> */}
      <SponsorContainer semilarge>
        <Sponsor src={nitor} alt="Nitor" invert />
        <Sponsor src={ABB} alt="ABB" whiteBG />
        <Sponsor src={tek} alt="TEK" invert />
        <Sponsor src={hsy} alt="HSY"/>
        <Sponsor src={espoo} alt="Espoo" />
        {/* <Sponsor src={knowit} alt="Knowit" /> */}
        {/* <Sponsor src={granlund} alt="Granlund" /> */}
      </SponsorContainer>
      <SponsorContainer>
        {/* <Sponsor src={tter} alt="TTER" /> */}
        <Sponsor src={wibax} alt="Wibax" invert />
        {/* <Sponsor src={oikia} alt="oikia" /> */}
        {/* <Sponsor src={fatLizart} alt="fatLizart" /> */}
        <Sponsor src={heko} alt="Helsingin Ekonomit" /> 
        <Sponsor src={fonum} alt="Fonum" invert />
        <Sponsor src={nocfo} alt="Nocfo" />
        {/* <Sponsor src={aInsinoorit} alt="a-insinoorit" /> */}
        {/* <Sponsor src={avp} alt="Aalto Ventures Program" /> */}
      </SponsorContainer>
      <SponsorContainer>
        <Sponsor src={celsius} alt="Celsius" /> 
        <Sponsor src={bos} alt="BOS" /> 
        <Sponsor src={rajupaja} alt="Rajupaja" />
        <Sponsor src={granlund} alt="Granlund" invert />
      </SponsorContainer>
    </div>
  );
};

export default SponsorPyramid;
